<span>{{ (hasCuttingLine() ? 'GENERAL.CONDITION.YES' : 'GENERAL.CONDITION.NO') | bmsTranslate }}</span>
